<template>
  <el-table-column :label="label" :prop="prop" class-name="fee" :sortable="sortable" :formatter="formatter" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '料金'
    },
    prop: {
      type: String,
      default: 'fee'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    formatter: {
      type: Function,
      default: () => '0'
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.fee {
      width: 15em;
    }
  }
  td.fee {
    text-align: right;
  }
}
</style>
